import React, { Component } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

export class ConfigMenu extends Component {
  constructor (props) {
    super(props);
    this.state = {
      companyId: props.companyId,
    };
  }

  render () {
    return (
      <SideNav
        onSelect={(selected) => {
                    const to = '/config' + selected + (this.state.companyId ? '/' + this.state.companyId : '');
                    if (window.location.pathname !== to) {
                        this.props.history.push(to);
                    }
        }}
      >
        <SideNav.Toggle />
        <SideNav.Nav selected={this.props.selected}>
          <NavItem eventKey="company">
            <NavIcon>
              <i className="fa fa-fw fa-building sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              Company
            </NavText>
          </NavItem>
          <NavItem eventKey="users">
            <NavIcon>
              <i className="fa fa-fw fa-users sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              Users
            </NavText>
          </NavItem>
          <NavItem eventKey="services">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-list-alt sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              Services
            </NavText>
          </NavItem>
          <NavItem eventKey="resources">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-bag-shopping sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              Resources
            </NavText>
          </NavItem>
          <NavItem eventKey="calendar">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-calendar-days sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              Calendar
            </NavText>
          </NavItem>
          <NavItem eventKey="params">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-sliders sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              Profiles
            </NavText>
          </NavItem>
          <NavItem eventKey="charts">
            <NavIcon>
              <i className="fa fa-fw fa-line-chart sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              Charts
            </NavText>
            <NavItem eventKey="charts/day">
              <NavText>
                Day Chart
              </NavText>
            </NavItem>
            <NavItem eventKey="charts/resource">
              <NavText>
                Resource Chart
              </NavText>
            </NavItem>
          </NavItem>
          <NavItem eventKey="qrcode">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-qrcode sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              QR-code
            </NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
    );
  }
}
